import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DragDropContext } from 'react-beautiful-dnd';
import {
	onDragEndEventQuiz,
	onDragStartEvent,
	onDragUpdateEvent,
} from '~/helpers';
// import QuestionOverviewPortal from '~/portals/question-overview-portal';
import SidebarWidgetPortal from '~/portals/sidebar-widget-portal';
import EntityBuilderHeader from '~/components/common/entity-builder-header';
import QuizWorkspace from '~/components/quizzes/quiz-workspace';

/**
 * Main component for our Quiz Builder
 *
 * @param {Object} props
 * @param {Object} props.workspace
 * @param {Object} props.data
 */
const QuizBuilder = ( { workspace, data } ) => (
	<DragDropContext
		onDragStart={ ( result ) => {
			onDragStartEvent( result );
		} }
		onDragEnd={ ( result ) => {
			onDragEndEventQuiz( result );
		} }
		onDragUpdate={ ( result ) => {
			onDragUpdateEvent( result );
		} }
	>
		<div className="ld__builder--app">
			<main>
				<EntityBuilderHeader
					totalEntities={ workspace.present.questions.length }
					type={ data.labels.quiz }
					singular={ data.labels.question }
					plural={ data.labels.questions }
					showUndo={ 0 < workspace.past.length }
				/>

				<QuizWorkspace
					totalLessons={ workspace.present.questions.length }
				/>
			</main>
		</div>

		{ /* The following components are rendered as portals, the el prop need to match the ID of the sidebar metabox */ }
		{ /* <QuestionOverviewPortal title="Questions for this quiz" el="quiz_navigation_app" /> */ }
		<SidebarWidgetPortal
			title="Questions"
			content="questions"
			type="question"
			el="sfwd-questions-app"
		/>
	</DragDropContext>
);

/**
 * Valid props
 */
QuizBuilder.propTypes = {
	workspace: PropTypes.object,
	data: PropTypes.shape( {
		labels: PropTypes.object,
	} ),
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = ( state ) => ( {
	...state,
} );

/**
 *
 */
const mapDispatchToProps = () => ( {} );

export default connect( mapStateToProps, mapDispatchToProps )( QuizBuilder );
